import gql from 'graphql-tag'

export const QueryAllAufschaltungen = gql(`query allAufschaltungen {
    listAufschaltungen {
        id
        auid
        title
        nickname
        feeds {
            id
            nickname
            profile_id
            api_id
            api_kind
            app_id
            is_activated
            is_activation_disabled
            last_activation_change_reason
            base_url
            schema_doc_md
            for_internal_apikp_use_only
            feed_url
            graphql_endpoint_url
            graphql_example_query
            s3push_activated
            s3push_parameters {
                s3_provider
                s3_url
                accesskey
                secretaccesskey
            }
            s3push_customer_permissions {
                activate
                deactivate
                update
            }
            transfer_params {
                url
                public_key
                static_ips
            }
            conversions {
                nickname
                feed_url
            }
        }
        profiles {
            id
            nickname
            ored_tag_regexps
            query_ored_tag_regexps
        }
        apis {
            id
            nickname
            kind
            for_internal_apikp_use_only
        }
        apps {
            id
            nickname
        }
      }
  }`)



// WEBPACK FOOTER //
// ./src/graphql/QueryAllAufschaltungen.js